var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect, _path29, _path30, _circle3, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _rect2, _path41, _path42, _path43, _path44;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanda(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "39.01 30.4 78.41 94.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "butt"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 109.50 34.96   L 106.91 35.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51465b",
    vectorEffect: "non-scaling-stroke",
    d: "   M 106.91 35.29   Q 100.28 34.51 97.46 40.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 97.46 40.25   Q 96.91 39.22 95.59 39.08"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 95.59 39.08   Q 94.95 37.72 93.58 37.23   Q 91.58 36.53 91.52 36.50   Q 84.97 33.21 77.76 31.88   Q 77.64 31.86 76.27 31.53   Q 73.50 30.87 73.85 33.68   A 0.31 0.30 -85.4 0 1 73.46 34.02   Q 70.84 33.14 66.25 32.25   Q 64.56 31.92 63.96 33.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#08030b",
    vectorEffect: "non-scaling-stroke",
    d: "   M 63.96 33.00   Q 63.68 32.97 63.65 31.91"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 108.71 55.00   Q 108.40 55.25 108.00 55.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8c829f",
    vectorEffect: "non-scaling-stroke",
    d: "   M 108.00 55.29   Q 107.79 55.25 107.75 55.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 107.75 55.04   Q 109.05 53.96 107.93 53.78   Q 107.61 53.73 107.10 53.90   Q 104.96 54.59 103.25 53.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d6081",
    vectorEffect: "non-scaling-stroke",
    d: "   M 106.91 35.29   Q 101.58 36.60 98.28 40.82   Q 96.72 42.82 97.46 40.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 55.04 44.25   Q 55.91 41.60 58.21 39.95   Q 59.56 38.98 60.96 37.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3b3f55",
    vectorEffect: "non-scaling-stroke",
    d: "   M 60.96 37.38   Q 61.93 37.23 63.04 36.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#150c1e",
    vectorEffect: "non-scaling-stroke",
    d: "   M 63.04 36.25   Q 63.65 36.40 64.00 36.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3b3f55",
    vectorEffect: "non-scaling-stroke",
    d: "   M 64.00 36.04   Q 64.67 34.65 63.29 34.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09bab",
    vectorEffect: "non-scaling-stroke",
    d: "   M 95.59 39.08   L 103.25 53.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 103.25 53.04   L 104.29 55.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#ebe6f3",
    vectorEffect: "non-scaling-stroke",
    d: "   M 104.29 55.00   L 104.56 57.01   A 0.92 0.79 -81.1 0 0 104.95 57.64   Q 105.78 58.14 104.50 58.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 104.50 58.29   L 98.27 58.34   A 0.80 0.73 -8.6 0 1 97.53 57.84   Q 95.53 51.99 90.00 49.50   Q 84.28 46.92 78.31 50.31   Q 73.98 52.78 72.20 58.59   A 0.48 0.45 18.7 0 1 71.59 58.87   Q 69.61 58.16 66.60 58.71   A 0.77 0.77 74.3 0 1 65.75 58.23   Q 62.49 49.66 53.25 50.00   Q 52.12 50.04 52.00 49.54"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09bab",
    vectorEffect: "non-scaling-stroke",
    d: "   M 52.00 49.54   L 55.04 44.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 55.04 44.25   Q 59.01 39.15 65.10 36.80   A 0.95 0.91 62.8 0 0 65.51 35.42   L 63.96 33.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#706879",
    vectorEffect: "non-scaling-stroke",
    d: "   M 107.75 55.04   L 104.29 55.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#706879",
    vectorEffect: "non-scaling-stroke",
    d: "   M 104.50 58.29   Q 109.19 59.87 108.00 55.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 104.57 78.70   Q 96.66 84.53 87.00 86.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 87.00 86.46   L 74.06 87.53   A 0.57 0.54 -2.9 0 0 73.55 88.07   Q 73.55 91.22 75.54 93.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 75.54 93.75   Q 75.49 95.01 76.29 96.00"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.29 96.00   Q 75.73 98.51 77.66 99.32   Q 79.03 99.90 79.15 99.96   Q 83.20 102.16 86.56 101.56   Q 96.29 99.85 102.81 90.81   Q 104.62 88.30 105.50 90.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 105.50 90.96   L 95.92 98.92   Q 95.09 99.61 96.17 99.73   Q 100.28 100.17 103.44 103.31   Q 105.36 105.22 108.50 103.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#655f6a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 108.50 103.71   Q 110.87 103.57 110.04 101.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 110.04 101.25   Q 110.76 100.39 110.79 99.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 111.55 101.74   Q 111.41 107.39 110.04 112.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 110.04 112.75   Q 110.69 108.75 110.31 105.28   A 0.98 0.97 71.1 0 0 108.83 104.55   Q 107.62 105.30 106.29 105.36   Q 105.23 105.40 103.94 104.52   Q 101.99 103.20 99.70 101.75   Q 98.20 100.81 96.01 102.06   L 92.47 104.08   A 1.23 0.42 -24.6 0 0 91.81 104.71   Q 91.59 105.58 92.81 105.94   Q 95.22 106.64 95.75 109.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51465b",
    vectorEffect: "non-scaling-stroke",
    d: "   M 95.75 109.29   Q 93.25 105.60 89.04 107.01   Q 87.04 107.68 86.37 110.10"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 86.37 110.10   Q 83.55 117.63 88.98 123.89"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#241b30",
    vectorEffect: "non-scaling-stroke",
    d: "   M 84.50 119.29   Q 85.36 117.08 84.00 115.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 84.00 115.21   L 85.31 109.15   Q 85.62 107.74 84.46 108.64   Q 81.97 110.58 78.75 111.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#241b30",
    vectorEffect: "non-scaling-stroke",
    d: "   M 78.75 111.04   Q 76.32 111.05 78.00 110.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#706879",
    vectorEffect: "non-scaling-stroke",
    d: "   M 78.00 110.04   Q 79.37 109.30 78.56 108.40   A 1.19 0.92 -18.2 0 0 77.69 108.09   Q 69.96 108.54 62.25 107.75   Q 59.45 107.46 49.37 108.20   Q 49.24 108.21 48.13 108.23   Q 46.18 108.27 47.45 109.59   A 1.38 1.06 -15.8 0 0 48.32 109.94   L 55.04 110.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#241b30",
    vectorEffect: "non-scaling-stroke",
    d: "   M 55.04 110.14   Q 50.97 111.94 46.96 110.21   Q 46.59 110.05 46.22 109.58   Q 45.45 108.62 44.55 109.38   Q 44.00 109.85 43.89 110.83   Q 43.42 115.06 45.06 118.19   Q 45.81 119.61 45.46 120.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#57597b",
    vectorEffect: "non-scaling-stroke",
    d: "   M 53.00 32.79   Q 52.98 33.57 54.00 33.75   Q 57.64 34.39 60.96 37.38"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 52.00 49.54   Q 51.22 49.89 50.54 49.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 49.71 48.25   Q 49.80 47.09 48.50 45.50   Q 46.45 42.97 46.71 38.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#484868",
    vectorEffect: "non-scaling-stroke",
    d: "   M 62.98 34.95   Q 63.12 35.89 64.00 36.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#484868",
    vectorEffect: "non-scaling-stroke",
    d: "   M 63.04 36.25   Q 58.57 33.71 53.50 32.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9f99aa",
    vectorEffect: "non-scaling-stroke",
    d: "   M 84.00 115.21   Q 76.40 115.30 74.00 115.50   Q 67.79 116.01 63.56 111.69   Q 63.14 111.26 63.73 111.25   L 78.75 111.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1dde4",
    vectorEffect: "non-scaling-stroke",
    d: "   M 108.50 103.71   L 107.01 90.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09bab",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.71 93.75   Q 76.09 93.24 75.54 93.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8b7f9d",
    vectorEffect: "non-scaling-stroke",
    d: "   M 78.00 110.04   Q 66.48 109.30 55.04 110.14"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D212A",
    vectorEffect: "non-scaling-stroke",
    d: "   M 110.04 112.75   L 109.19 115.63"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d6081",
    vectorEffect: "non-scaling-stroke",
    d: "   M 86.37 110.10   Q 91.80 104.65 95.88 111.14   Q 96.94 112.81 96.56 111.19   Q 96.32 110.17 95.75 109.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#827990",
    vectorEffect: "non-scaling-stroke",
    d: "   M 110.04 101.25   Q 109.64 96.24 108.42 91.38   Q 108.30 90.88 108.05 90.60   Q 107.39 89.87 107.01 90.68"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09bab",
    vectorEffect: "non-scaling-stroke",
    d: "   M 107.01 90.68   L 105.50 90.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#a09bab",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.29 96.00   Q 77.64 95.20 76.71 93.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1D212A",
    vectorEffect: "non-scaling-stroke",
    d: "   M 76.71 93.75   Q 81.69 90.68 86.75 87.75   Q 87.58 87.27 87.00 86.46"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3e3746",
    vectorEffect: "non-scaling-stroke",
    d: "   M 80.83 72.16   Q 88.25 75.13 93.44 69.44   Q 99.61 62.67 94.80 55.05"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 94.80 55.05   Q 90.20 48.42 82.81 50.06   Q 76.24 51.52 74.15 57.24   Q 72.53 61.66 74.12 65.75   Q 75.83 70.17 80.83 72.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b9b5c0",
    vectorEffect: "non-scaling-stroke",
    d: "   M 94.80 55.05   Q 83.66 49.80 75.30 58.08   A 3.52 3.51 -23.4 0 0 74.26 60.69   Q 74.49 67.96 80.83 72.16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3e3746",
    vectorEffect: "non-scaling-stroke",
    d: "   M 52.21 51.25   Q 50.46 52.01 49.42 53.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#597384",
    vectorEffect: "non-scaling-stroke",
    d: "   M 49.42 53.21   Q 42.75 57.16 45.21 64.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3e3746",
    vectorEffect: "non-scaling-stroke",
    d: "   M 45.21 64.50   Q 46.25 68.39 49.75 70.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 49.75 70.29   Q 59.85 74.80 64.36 64.72"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3e3746",
    vectorEffect: "non-scaling-stroke",
    d: "   M 64.36 64.72   Q 66.97 54.39 56.75 51.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616570",
    vectorEffect: "non-scaling-stroke",
    d: "   M 56.75 51.29   Q 54.46 50.81 52.21 51.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9699ab",
    vectorEffect: "non-scaling-stroke",
    d: "   M 56.75 51.29   Q 54.47 52.44 52.21 51.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b9b5c0",
    vectorEffect: "non-scaling-stroke",
    d: "   M 64.36 64.72   Q 58.55 71.33 49.75 70.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8fa7bf",
    vectorEffect: "non-scaling-stroke",
    d: "   M 45.21 64.50   Q 48.22 59.22 49.42 53.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#150c1e",
    vectorEffect: "non-scaling-stroke",
    d: "   M 65.04 67.50   L 64.50 68.21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 64.50 68.21   Q 56.06 77.18 46.82 69.94   Q 45.60 68.99 46.00 70.48   Q 47.53 76.29 52.57 79.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#655f6a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 52.57 79.39   Q 57.19 83.75 63.50 83.71"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 63.50 83.71   Q 68.01 83.25 72.29 84.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#655f6a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 72.29 84.50   Q 72.93 86.54 74.93 86.39   Q 76.49 86.27 76.57 86.27   Q 85.72 86.43 94.12 83.37   Q 100.24 81.13 103.40 77.63   Q 107.29 73.33 108.09 67.20   Q 108.37 65.03 108.48 63.82   Q 108.64 62.14 108.49 60.39   A 0.76 0.67 86.2 0 0 107.78 59.69   L 104.50 59.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 104.50 59.79   L 99.31 59.79   A 0.43 0.41 84.2 0 0 98.91 60.30   Q 100.82 70.80 91.00 73.50   Q 75.70 77.70 72.03 62.49   Q 71.01 58.26 67.62 60.17   A 1.32 1.19 -8.7 0 0 67.02 60.90   L 65.04 67.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1dde4",
    vectorEffect: "non-scaling-stroke",
    d: "   M 104.50 59.79   Q 106.30 67.53 102.61 73.31   Q 99.79 77.71 93.52 80.50   Q 88.09 82.91 82.00 83.49   Q 77.14 83.94 72.29 84.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#e1dde4",
    vectorEffect: "non-scaling-stroke",
    d: "   M 63.50 83.71   L 63.60 83.05   A 0.56 0.55 -78.3 0 0 63.20 82.43   L 52.57 79.39"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#918a98",
    vectorEffect: "non-scaling-stroke",
    d: "   M 64.50 68.21   Q 66.50 70.87 69.37 69.65   Q 70.16 69.32 70.44 68.64   Q 70.99 67.30 69.00 67.25   Q 66.42 67.19 65.04 67.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#545263",
    vectorEffect: "non-scaling-stroke",
    d: "   M 42.75 85.04   Q 40.22 84.25 40.44 86.06   Q 40.75 88.65 42.50 92.60"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616570",
    vectorEffect: "non-scaling-stroke",
    d: "   M 42.50 92.60   Q 51.47 94.53 48.46 103.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#545263",
    vectorEffect: "non-scaling-stroke",
    d: "   M 48.46 103.50   Q 45.47 104.56 46.93 106.61   A 1.24 1.09 -12.6 0 0 47.75 107.06   Q 52.25 107.56 56.75 106.96"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#616570",
    vectorEffect: "non-scaling-stroke",
    d: "   M 56.75 106.96   L 76.86 107.00   A 1.13 1.12 81.3 0 0 77.93 105.53   Q 75.18 96.79 72.44 87.81   Q 71.50 84.74 68.85 84.88   Q 67.27 84.97 67.14 84.96   Q 54.94 84.41 42.75 85.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#acb4c7",
    vectorEffect: "non-scaling-stroke",
    d: "   M 56.75 106.96   Q 55.10 107.05 54.27 105.93   A 0.89 0.79 66.1 0 0 53.50 105.58   Q 50.36 105.95 48.46 103.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#acb4c7",
    vectorEffect: "non-scaling-stroke",
    d: "   M 42.50 92.60   Q 45.62 89.06 42.75 85.04"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#251d31",
    vectorEffect: "non-scaling-stroke",
    d: "   M 41.71 94.25   Q 38.88 97.18 40.75 101.25   Q 42.52 105.10 45.40 104.26   Q 47.62 103.62 48.38 101.06   Q 49.57 97.08 45.54 94.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#51465b",
    vectorEffect: "non-scaling-stroke",
    d: "   M 45.54 94.50   Q 43.68 93.56 41.71 94.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d6081",
    vectorEffect: "non-scaling-stroke",
    d: "   M 45.54 94.50   Q 44.76 95.19 43.73 95.09   Q 43.25 95.04 42.80 95.21   Q 41.62 95.64 41.71 94.25"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#302c35",
    vectorEffect: "non-scaling-stroke",
    d: "   M 78.50 102.29   Q 77.91 104.06 79.04 105.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#706879",
    vectorEffect: "non-scaling-stroke",
    d: "   M 79.04 105.50   Q 79.11 107.51 81.02 106.55   Q 85.02 104.55 89.11 102.76   A 0.73 0.42 -23.4 0 0 89.61 102.08   Q 89.48 101.79 88.75 101.99   Q 85.90 102.75 83.00 103.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#302c35",
    vectorEffect: "non-scaling-stroke",
    d: "   M 83.00 103.29   Q 81.59 101.81 79.54 101.75"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#706879",
    vectorEffect: "non-scaling-stroke",
    d: "   M 79.54 101.75   Q 76.27 98.54 78.50 102.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9890a3",
    vectorEffect: "non-scaling-stroke",
    d: "   M 79.54 101.75   Q 79.12 102.20 78.50 102.29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#9890a3",
    vectorEffect: "non-scaling-stroke",
    d: "   M 83.00 103.29   Q 81.35 104.96 79.04 105.50"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#655f6a",
    vectorEffect: "non-scaling-stroke",
    d: "   M 93.74 102.79   Q 94.47 102.48 95.10 101.98   Q 96.29 101.03 94.75 101.25   Q 91.05 101.77 90.81 103.31   Q 90.70 104.07 93.74 102.79"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#706879",
    vectorEffect: "non-scaling-stroke",
    d: "   M 88.6524 104.4132   A 0.58 0.58 0.0 0 0 87.8680 104.1733   L 80.1687 108.2671   A 0.58 0.58 0.0 0 0 79.9288 109.0515   L 79.9476 109.0868   A 0.58 0.58 0.0 0 0 80.7320 109.3267   L 88.4313 105.2329   A 0.58 0.58 0.0 0 0 88.6712 104.4485   L 88.6524 104.4132"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b9b5c0",
    vectorEffect: "non-scaling-stroke",
    d: "   M 60.14 61.99   A 1.85 1.85 0.0 0 0 58.29 60.14   A 1.85 1.85 0.0 0 0 56.44 61.99   A 1.85 1.85 0.0 0 0 58.29 63.84   A 1.85 1.85 0.0 0 0 60.14 61.99"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#b9b5c0",
    vectorEffect: "non-scaling-stroke",
    d: "   M 85.03 63.78   A 1.84 1.84 0.0 0 0 83.19 61.94   A 1.84 1.84 0.0 0 0 81.35 63.78   A 1.84 1.84 0.0 0 0 83.19 65.62   A 1.84 1.84 0.0 0 0 85.03 63.78"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#848185",
    vectorEffect: "non-scaling-stroke",
    d: "   M 69.00 74.83   Q 72.04 75.54 72.40 72.80   Q 72.45 72.42 72.03 72.61   L 68.99 74.00   Q 67.80 74.55 69.00 74.83"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6d6081",
    vectorEffect: "non-scaling-stroke",
    d: "   M 88.8727 88.4158   A 0.33 0.33 0.0 0 0 88.4253 88.2833   L 78.7407 93.5416   A 0.33 0.33 0.0 0 0 78.6082 93.9890   L 78.6273 94.0242   A 0.33 0.33 0.0 0 0 79.0747 94.1567   L 88.7593 88.8984   A 0.33 0.33 0.0 0 0 88.8918 88.4510   L 88.8727 88.4158"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#dce3ea",
    vectorEffect: "non-scaling-stroke",
    d: "   M 59.80 96.20   A 2.73 2.73 0.0 0 0 57.07 93.47   A 2.73 2.73 0.0 0 0 54.34 96.20   A 2.73 2.73 0.0 0 0 57.07 98.93   A 2.73 2.73 0.0 0 0 59.80 96.20"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#08030b",
    d: "   M 109.50 34.96   L 106.91 35.29   Q 100.28 34.51 97.46 40.25   Q 96.91 39.22 95.59 39.08   Q 94.95 37.72 93.58 37.23   Q 91.58 36.53 91.52 36.50   Q 84.97 33.21 77.76 31.88   Q 77.64 31.86 76.27 31.53   Q 73.50 30.87 73.85 33.68   A 0.31 0.30 -85.4 0 1 73.46 34.02   Q 70.84 33.14 66.25 32.25   Q 64.56 31.92 63.96 33.00   Q 63.68 32.97 63.65 31.91   Q 67.91 30.71 72.10 32.37   A 0.62 0.58 -61.7 0 0 72.82 32.13   Q 74.04 30.26 76.06 30.69   Q 87.01 32.99 96.03 37.51   A 2.28 2.27 -51.5 0 0 98.51 37.22   Q 104.03 32.57 109.50 34.96   Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 95.59 39.08   L 103.25 53.04   L 104.29 55.00   L 104.56 57.01   A 0.92 0.79 -81.1 0 0 104.95 57.64   Q 105.78 58.14 104.50 58.29   L 98.27 58.34   A 0.80 0.73 -8.6 0 1 97.53 57.84   Q 95.53 51.99 90.00 49.50   Q 84.28 46.92 78.31 50.31   Q 73.98 52.78 72.20 58.59   A 0.48 0.45 18.7 0 1 71.59 58.87   Q 69.61 58.16 66.60 58.71   A 0.77 0.77 74.3 0 1 65.75 58.23   Q 62.49 49.66 53.25 50.00   Q 52.12 50.04 52.00 49.54   L 55.04 44.25   Q 59.01 39.15 65.10 36.80   A 0.95 0.91 62.8 0 0 65.51 35.42   L 63.96 33.00   Q 64.56 31.92 66.25 32.25   Q 70.84 33.14 73.46 34.02   A 0.31 0.30 -85.4 0 0 73.85 33.68   Q 73.50 30.87 76.27 31.53   Q 77.64 31.86 77.76 31.88   Q 84.97 33.21 91.52 36.50   Q 91.58 36.53 93.58 37.23   Q 94.95 37.72 95.59 39.08   Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#08030b",
    d: "   M 63.65 31.91   Q 63.68 32.97 63.96 33.00   L 65.51 35.42   A 0.95 0.91 62.8 0 1 65.10 36.80   Q 59.01 39.15 55.04 44.25   Q 55.91 41.60 58.21 39.95   Q 59.56 38.98 60.96 37.38   Q 61.93 37.23 63.04 36.25   Q 63.65 36.40 64.00 36.04   Q 64.67 34.65 63.29 34.00   Q 63.08 33.27 63.65 31.91   Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#221430",
    d: "   M 62.98 34.95   Q 63.12 35.89 64.00 36.04   Q 63.65 36.40 63.04 36.25   Q 58.57 33.71 53.50 32.71   Q 58.63 32.07 62.98 34.95   Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 53.00 32.79   Q 52.98 33.57 54.00 33.75   Q 57.64 34.39 60.96 37.38   Q 59.56 38.98 58.21 39.95   Q 55.91 41.60 55.04 44.25   L 52.00 49.54   Q 51.22 49.89 50.54 49.50   L 49.71 48.25   Q 49.80 47.09 48.50 45.50   Q 46.45 42.97 46.71 38.75   Q 48.21 34.09 53.00 32.79   Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d7b9f",
    d: "   M 53.00 32.79   L 53.50 32.71   Q 58.57 33.71 63.04 36.25   Q 61.93 37.23 60.96 37.38   Q 57.64 34.39 54.00 33.75   Q 52.98 33.57 53.00 32.79   Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#6d7b9f",
    d: "   M 63.29 34.00   Q 64.67 34.65 64.00 36.04   Q 63.12 35.89 62.98 34.95   L 63.29 34.00   Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#9988aa",
    d: "   M 106.91 35.29   Q 101.58 36.60 98.28 40.82   Q 96.72 42.82 97.46 40.25   Q 100.28 34.51 106.91 35.29   Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 106.91 35.29   L 109.50 34.96   Q 112.03 36.00 113.55 38.08   Q 114.95 40.00 115.00 42.72   Q 115.11 48.11 110.94 51.69   Q 109.09 53.28 108.71 55.00   Q 108.40 55.25 108.00 55.29   Q 107.79 55.25 107.75 55.04   Q 109.05 53.96 107.93 53.78   Q 107.61 53.73 107.10 53.90   Q 104.96 54.59 103.25 53.04   L 95.59 39.08   Q 96.91 39.22 97.46 40.25   Q 96.72 42.82 98.28 40.82   Q 101.58 36.60 106.91 35.29   Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#08030b",
    d: "   M 46.71 38.75   Q 46.45 42.97 48.50 45.50   Q 49.80 47.09 49.71 48.25   Q 44.97 44.60 46.71 38.75   Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#08030b",
    d: "   M 104.50 58.29   Q 109.19 59.87 108.00 55.29   Q 108.40 55.25 108.71 55.00   Q 109.54 61.32 109.00 66.75   Q 108.36 73.18 104.57 78.70   Q 96.66 84.53 87.00 86.46   L 74.06 87.53   A 0.57 0.54 -2.9 0 0 73.55 88.07   Q 73.55 91.22 75.54 93.75   Q 75.49 95.01 76.29 96.00   Q 75.73 98.51 77.66 99.32   Q 79.03 99.90 79.15 99.96   Q 83.20 102.16 86.56 101.56   Q 96.29 99.85 102.81 90.81   Q 104.62 88.30 105.50 90.96   L 95.92 98.92   Q 95.09 99.61 96.17 99.73   Q 100.28 100.17 103.44 103.31   Q 105.36 105.22 108.50 103.71   Q 110.87 103.57 110.04 101.25   Q 110.76 100.39 110.79 99.25   Q 110.98 100.84 111.55 101.74   Q 111.41 107.39 110.04 112.75   Q 110.69 108.75 110.31 105.28   A 0.98 0.97 71.1 0 0 108.83 104.55   Q 107.62 105.30 106.29 105.36   Q 105.23 105.40 103.94 104.52   Q 101.99 103.20 99.70 101.75   Q 98.20 100.81 96.01 102.06   L 92.47 104.08   A 1.23 0.42 -24.6 0 0 91.81 104.71   Q 91.59 105.58 92.81 105.94   Q 95.22 106.64 95.75 109.29   Q 93.25 105.60 89.04 107.01   Q 87.04 107.68 86.37 110.10   Q 83.55 117.63 88.98 123.89   Q 86.06 122.10 84.50 119.29   Q 85.36 117.08 84.00 115.21   L 85.31 109.15   Q 85.62 107.74 84.46 108.64   Q 81.97 110.58 78.75 111.04   Q 76.32 111.05 78.00 110.04   Q 79.37 109.30 78.56 108.40   A 1.19 0.92 -18.2 0 0 77.69 108.09   Q 69.96 108.54 62.25 107.75   Q 59.45 107.46 49.37 108.20   Q 49.24 108.21 48.13 108.23   Q 46.18 108.27 47.45 109.59   A 1.38 1.06 -15.8 0 0 48.32 109.94   L 55.04 110.14   Q 50.97 111.94 46.96 110.21   Q 46.59 110.05 46.22 109.58   Q 45.45 108.62 44.55 109.38   Q 44.00 109.85 43.89 110.83   Q 43.42 115.06 45.06 118.19   Q 45.81 119.61 45.46 120.50   Q 41.48 113.98 44.49 106.89   A 1.22 0.90 -52.4 0 0 44.51 105.97   Q 44.08 105.15 43.06 104.98   Q 42.46 104.88 42.16 104.65   Q 39.75 102.80 39.25 99.00   Q 38.81 95.67 40.65 93.61   A 1.18 1.00 -30.3 0 0 40.95 92.76   Q 40.52 89.11 39.13 85.85   A 1.34 1.31 76.7 0 1 40.24 84.00   L 53.05 83.22   Q 55.88 83.05 53.41 81.69   Q 46.01 77.60 44.60 69.53   Q 44.12 66.75 43.57 63.99   Q 42.88 60.59 43.45 58.49   Q 44.72 53.85 49.21 51.22   Q 50.25 50.61 50.54 49.50   Q 51.22 49.89 52.00 49.54   Q 52.12 50.04 53.25 50.00   Q 62.49 49.66 65.75 58.23   A 0.77 0.77 74.3 0 0 66.60 58.71   Q 69.61 58.16 71.59 58.87   A 0.48 0.45 18.7 0 0 72.20 58.59   Q 73.98 52.78 78.31 50.31   Q 84.28 46.92 90.00 49.50   Q 95.53 51.99 97.53 57.84   A 0.80 0.73 -8.6 0 0 98.27 58.34   L 104.50 58.29   Z   M 80.83 72.16   Q 88.25 75.13 93.44 69.44   Q 99.61 62.67 94.80 55.05   Q 90.20 48.42 82.81 50.06   Q 76.24 51.52 74.15 57.24   Q 72.53 61.66 74.12 65.75   Q 75.83 70.17 80.83 72.16   Z   M 52.21 51.25   Q 50.46 52.01 49.42 53.21   Q 42.75 57.16 45.21 64.50   Q 46.25 68.39 49.75 70.29   Q 59.85 74.80 64.36 64.72   Q 66.97 54.39 56.75 51.29   Q 54.46 50.81 52.21 51.25   Z   M 65.04 67.50   L 64.50 68.21   Q 56.06 77.18 46.82 69.94   Q 45.60 68.99 46.00 70.48   Q 47.53 76.29 52.57 79.39   Q 57.19 83.75 63.50 83.71   Q 68.01 83.25 72.29 84.50   Q 72.93 86.54 74.93 86.39   Q 76.49 86.27 76.57 86.27   Q 85.72 86.43 94.12 83.37   Q 100.24 81.13 103.40 77.63   Q 107.29 73.33 108.09 67.20   Q 108.37 65.03 108.48 63.82   Q 108.64 62.14 108.49 60.39   A 0.76 0.67 86.2 0 0 107.78 59.69   L 104.50 59.79   L 99.31 59.79   A 0.43 0.41 84.2 0 0 98.91 60.30   Q 100.82 70.80 91.00 73.50   Q 75.70 77.70 72.03 62.49   Q 71.01 58.26 67.62 60.17   A 1.32 1.19 -8.7 0 0 67.02 60.90   L 65.04 67.50   Z   M 42.75 85.04   Q 40.22 84.25 40.44 86.06   Q 40.75 88.65 42.50 92.60   Q 51.47 94.53 48.46 103.50   Q 45.47 104.56 46.93 106.61   A 1.24 1.09 -12.6 0 0 47.75 107.06   Q 52.25 107.56 56.75 106.96   L 76.86 107.00   A 1.13 1.12 81.3 0 0 77.93 105.53   Q 75.18 96.79 72.44 87.81   Q 71.50 84.74 68.85 84.88   Q 67.27 84.97 67.14 84.96   Q 54.94 84.41 42.75 85.04   Z   M 41.71 94.25   Q 38.88 97.18 40.75 101.25   Q 42.52 105.10 45.40 104.26   Q 47.62 103.62 48.38 101.06   Q 49.57 97.08 45.54 94.50   Q 43.68 93.56 41.71 94.25   Z   M 78.50 102.29   Q 77.91 104.06 79.04 105.50   Q 79.11 107.51 81.02 106.55   Q 85.02 104.55 89.11 102.76   A 0.73 0.42 -23.4 0 0 89.61 102.08   Q 89.48 101.79 88.75 101.99   Q 85.90 102.75 83.00 103.29   Q 81.59 101.81 79.54 101.75   Q 76.27 98.54 78.50 102.29   Z   M 93.74 102.79   Q 94.47 102.48 95.10 101.98   Q 96.29 101.03 94.75 101.25   Q 91.05 101.77 90.81 103.31   Q 90.70 104.07 93.74 102.79   Z   M 88.6524 104.4132   A 0.58 0.58 0.0 0 0 87.8680 104.1733   L 80.1687 108.2671   A 0.58 0.58 0.0 0 0 79.9288 109.0515   L 79.9476 109.0868   A 0.58 0.58 0.0 0 0 80.7320 109.3267   L 88.4313 105.2329   A 0.58 0.58 0.0 0 0 88.6712 104.4485   L 88.6524 104.4132   Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 94.80 55.05   Q 83.66 49.80 75.30 58.08   A 3.52 3.51 -23.4 0 0 74.26 60.69   Q 74.49 67.96 80.83 72.16   Q 75.83 70.17 74.12 65.75   Q 72.53 61.66 74.15 57.24   Q 76.24 51.52 82.81 50.06   Q 90.20 48.42 94.80 55.05   Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9c6d4",
    d: "   M 56.75 51.29   Q 54.47 52.44 52.21 51.25   Q 54.46 50.81 56.75 51.29   Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#736b81",
    d: "   M 52.21 51.25   Q 54.47 52.44 56.75 51.29   Q 66.97 54.39 64.36 64.72   Q 58.55 71.33 49.75 70.29   Q 46.25 68.39 45.21 64.50   Q 48.22 59.22 49.42 53.21   Q 50.46 52.01 52.21 51.25   Z   M 60.14 61.99   A 1.85 1.85 0.0 0 0 58.29 60.14   A 1.85 1.85 0.0 0 0 56.44 61.99   A 1.85 1.85 0.0 0 0 58.29 63.84   A 1.85 1.85 0.0 0 0 60.14 61.99   Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#736b81",
    d: "   M 94.80 55.05   Q 99.61 62.67 93.44 69.44   Q 88.25 75.13 80.83 72.16   Q 74.49 67.96 74.26 60.69   A 3.52 3.51 -23.4 0 1 75.30 58.08   Q 83.66 49.80 94.80 55.05   Z   M 85.03 63.78   A 1.84 1.84 0.0 0 0 83.19 61.94   A 1.84 1.84 0.0 0 0 81.35 63.78   A 1.84 1.84 0.0 0 0 83.19 65.62   A 1.84 1.84 0.0 0 0 85.03 63.78   Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#08030b",
    d: "   M 103.25 53.04   Q 104.96 54.59 107.10 53.90   Q 107.61 53.73 107.93 53.78   Q 109.05 53.96 107.75 55.04   L 104.29 55.00   L 103.25 53.04   Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#2a303c",
    d: "   M 49.42 53.21   Q 48.22 59.22 45.21 64.50   Q 42.75 57.16 49.42 53.21   Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7cce6",
    d: "   M 104.29 55.00   L 107.75 55.04   Q 107.79 55.25 108.00 55.29   Q 109.19 59.87 104.50 58.29   Q 105.78 58.14 104.95 57.64   A 0.92 0.79 -81.1 0 1 104.56 57.01   L 104.29 55.00   Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 104.50 59.79   Q 106.30 67.53 102.61 73.31   Q 99.79 77.71 93.52 80.50   Q 88.09 82.91 82.00 83.49   Q 77.14 83.94 72.29 84.50   Q 68.01 83.25 63.50 83.71   L 63.60 83.05   A 0.56 0.55 -78.3 0 0 63.20 82.43   L 52.57 79.39   Q 47.53 76.29 46.00 70.48   Q 45.60 68.99 46.82 69.94   Q 56.06 77.18 64.50 68.21   Q 66.50 70.87 69.37 69.65   Q 70.16 69.32 70.44 68.64   Q 70.99 67.30 69.00 67.25   Q 66.42 67.19 65.04 67.50   L 67.02 60.90   A 1.32 1.19 -8.7 0 1 67.62 60.17   Q 71.01 58.26 72.03 62.49   Q 75.70 77.70 91.00 73.50   Q 100.82 70.80 98.91 60.30   A 0.43 0.41 84.2 0 1 99.31 59.79   L 104.50 59.79   Z   M 69.00 74.83   Q 72.04 75.54 72.40 72.80   Q 72.45 72.42 72.03 72.61   L 68.99 74.00   Q 67.80 74.55 69.00 74.83   Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2bac8",
    d: "   M 72.29 84.50   Q 77.14 83.94 82.00 83.49   Q 88.09 82.91 93.52 80.50   Q 99.79 77.71 102.61 73.31   Q 106.30 67.53 104.50 59.79   L 107.78 59.69   A 0.76 0.67 86.2 0 1 108.49 60.39   Q 108.64 62.14 108.48 63.82   Q 108.37 65.03 108.09 67.20   Q 107.29 73.33 103.40 77.63   Q 100.24 81.13 94.12 83.37   Q 85.72 86.43 76.57 86.27   Q 76.49 86.27 74.93 86.39   Q 72.93 86.54 72.29 84.50   Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 58.29,
    cy: 61.99,
    r: 1.85
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 83.19,
    cy: 63.78,
    r: 1.84
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 64.36 64.72   Q 59.85 74.80 49.75 70.29   Q 58.55 71.33 64.36 64.72   Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#221430",
    d: "   M 64.50 68.21   L 65.04 67.50   Q 66.42 67.19 69.00 67.25   Q 70.99 67.30 70.44 68.64   Q 70.16 69.32 69.37 69.65   Q 66.50 70.87 64.50 68.21   Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#08030b",
    d: "   M 69.00 74.83   Q 67.80 74.55 68.99 74.00   L 72.03 72.61   Q 72.45 72.42 72.40 72.80   Q 72.04 75.54 69.00 74.83   Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 104.57 78.70   Q 109.81 88.88 110.79 99.25   Q 110.76 100.39 110.04 101.25   Q 109.64 96.24 108.42 91.38   Q 108.30 90.88 108.05 90.60   Q 107.39 89.87 107.01 90.68   L 105.50 90.96   Q 104.62 88.30 102.81 90.81   Q 96.29 99.85 86.56 101.56   Q 83.20 102.16 79.15 99.96   Q 79.03 99.90 77.66 99.32   Q 75.73 98.51 76.29 96.00   Q 77.64 95.20 76.71 93.75   Q 81.69 90.68 86.75 87.75   Q 87.58 87.27 87.00 86.46   Q 96.66 84.53 104.57 78.70   Z   M 88.8727 88.4158   A 0.33 0.33 0.0 0 0 88.4253 88.2833   L 78.7407 93.5416   A 0.33 0.33 0.0 0 0 78.6082 93.9890   L 78.6273 94.0242   A 0.33 0.33 0.0 0 0 79.0747 94.1567   L 88.7593 88.8984   A 0.33 0.33 0.0 0 0 88.8918 88.4510   L 88.8727 88.4158   Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2bac8",
    d: "   M 52.57 79.39   L 63.20 82.43   A 0.56 0.55 -78.3 0 1 63.60 83.05   L 63.50 83.71   Q 57.19 83.75 52.57 79.39   Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#b9c6d4",
    d: "   M 56.75 106.96   Q 55.10 107.05 54.27 105.93   A 0.89 0.79 66.1 0 0 53.50 105.58   Q 50.36 105.95 48.46 103.50   Q 51.47 94.53 42.50 92.60   Q 45.62 89.06 42.75 85.04   Q 54.94 84.41 67.14 84.96   Q 67.27 84.97 68.85 84.88   Q 71.50 84.74 72.44 87.81   Q 75.18 96.79 77.93 105.53   A 1.13 1.12 81.3 0 1 76.86 107.00   L 56.75 106.96   Z   M 59.80 96.20   A 2.73 2.73 0.0 0 0 57.07 93.47   A 2.73 2.73 0.0 0 0 54.34 96.20   A 2.73 2.73 0.0 0 0 57.07 98.93   A 2.73 2.73 0.0 0 0 59.80 96.20   Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa1ba",
    d: "   M 42.75 85.04   Q 45.62 89.06 42.50 92.60   Q 40.75 88.65 40.44 86.06   Q 40.22 84.25 42.75 85.04   Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 87.00 86.46   Q 87.58 87.27 86.75 87.75   Q 81.69 90.68 76.71 93.75   Q 76.09 93.24 75.54 93.75   Q 73.55 91.22 73.55 88.07   A 0.57 0.54 -2.9 0 1 74.06 87.53   L 87.00 86.46   Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#9988aa",
    x: -5.84,
    y: -0.35,
    transform: "translate(83.75,91.22) rotate(-28.5)",
    width: 11.68,
    height: 0.7,
    rx: 0.33
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2bac8",
    d: "   M 110.04 101.25   Q 110.87 103.57 108.50 103.71   L 107.01 90.68   Q 107.39 89.87 108.05 90.60   Q 108.30 90.88 108.42 91.38   Q 109.64 96.24 110.04 101.25   Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 107.01 90.68   L 108.50 103.71   Q 105.36 105.22 103.44 103.31   Q 100.28 100.17 96.17 99.73   Q 95.09 99.61 95.92 98.92   L 105.50 90.96   L 107.01 90.68   Z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 57.07,
    cy: 96.2,
    r: 2.73
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 76.71 93.75   Q 77.64 95.20 76.29 96.00   Q 75.49 95.01 75.54 93.75   Q 76.09 93.24 76.71 93.75   Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#9988aa",
    d: "   M 45.54 94.50   Q 44.76 95.19 43.73 95.09   Q 43.25 95.04 42.80 95.21   Q 41.62 95.64 41.71 94.25   Q 43.68 93.56 45.54 94.50   Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 41.71 94.25   Q 41.62 95.64 42.80 95.21   Q 43.25 95.04 43.73 95.09   Q 44.76 95.19 45.54 94.50   Q 49.57 97.08 48.38 101.06   Q 47.62 103.62 45.40 104.26   Q 42.52 105.10 40.75 101.25   Q 38.88 97.18 41.71 94.25   Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7cce6",
    d: "   M 79.54 101.75   Q 79.12 102.20 78.50 102.29   Q 76.27 98.54 79.54 101.75   Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#c2bac8",
    d: "   M 93.74 102.79   Q 90.70 104.07 90.81 103.31   Q 91.05 101.77 94.75 101.25   Q 96.29 101.03 95.10 101.98   Q 94.47 102.48 93.74 102.79   Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 110.04 112.75   L 109.19 115.63   Q 106.19 121.63 99.67 123.37   Q 96.57 124.19 93.44 124.94   Q 91.40 125.42 88.98 123.89   Q 83.55 117.63 86.37 110.10   Q 91.80 104.65 95.88 111.14   Q 96.94 112.81 96.56 111.19   Q 96.32 110.17 95.75 109.29   Q 95.22 106.64 92.81 105.94   Q 91.59 105.58 91.81 104.71   A 1.23 0.42 -24.6 0 1 92.47 104.08   L 96.01 102.06   Q 98.20 100.81 99.70 101.75   Q 101.99 103.20 103.94 104.52   Q 105.23 105.40 106.29 105.36   Q 107.62 105.30 108.83 104.55   A 0.98 0.97 71.1 0 1 110.31 105.28   Q 110.69 108.75 110.04 112.75   Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#58545f",
    d: "   M 79.54 101.75   Q 81.59 101.81 83.00 103.29   Q 81.35 104.96 79.04 105.50   Q 77.91 104.06 78.50 102.29   Q 79.12 102.20 79.54 101.75   Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 111.55 101.74   Q 116.65 101.81 117.31 105.38   Q 117.81 108.02 116.02 110.84   Q 113.76 114.39 109.19 115.63   L 110.04 112.75   Q 111.41 107.39 111.55 101.74   Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7cce6",
    d: "   M 79.04 105.50   Q 81.35 104.96 83.00 103.29   Q 85.90 102.75 88.75 101.99   Q 89.48 101.79 89.61 102.08   A 0.73 0.42 -23.4 0 1 89.11 102.76   Q 85.02 104.55 81.02 106.55   Q 79.11 107.51 79.04 105.50   Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#9fa1ba",
    d: "   M 48.46 103.50   Q 50.36 105.95 53.50 105.58   A 0.89 0.79 66.1 0 1 54.27 105.93   Q 55.10 107.05 56.75 106.96   Q 52.25 107.56 47.75 107.06   A 1.24 1.09 -12.6 0 1 46.93 106.61   Q 45.47 104.56 48.46 103.50   Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "#d7cce6",
    x: -4.94,
    y: -0.6,
    transform: "translate(84.30,106.75) rotate(-28.0)",
    width: 9.88,
    height: 1.2,
    rx: 0.58
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9988aa",
    d: "   M 95.75 109.29   Q 96.32 110.17 96.56 111.19   Q 96.94 112.81 95.88 111.14   Q 91.80 104.65 86.37 110.10   Q 87.04 107.68 89.04 107.01   Q 93.25 105.60 95.75 109.29   Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#d7cce6",
    d: "   M 78.00 110.04   Q 66.48 109.30 55.04 110.14   L 48.32 109.94   A 1.38 1.06 -15.8 0 1 47.45 109.59   Q 46.18 108.27 48.13 108.23   Q 49.24 108.21 49.37 108.20   Q 59.45 107.46 62.25 107.75   Q 69.96 108.54 77.69 108.09   A 1.19 0.92 -18.2 0 1 78.56 108.40   Q 79.37 109.30 78.00 110.04   Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "   M 84.00 115.21   Q 76.40 115.30 74.00 115.50   Q 67.79 116.01 63.56 111.69   Q 63.14 111.26 63.73 111.25   L 78.75 111.04   Q 81.97 110.58 84.46 108.64   Q 85.62 107.74 85.31 109.15   L 84.00 115.21   Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D212A",
    d: "   M 55.04 110.14   Q 66.48 109.30 78.00 110.04   Q 76.32 111.05 78.75 111.04   L 63.73 111.25   Q 63.14 111.26 63.56 111.69   Q 67.79 116.01 74.00 115.50   Q 76.40 115.30 84.00 115.21   Q 85.36 117.08 84.50 119.29   Q 74.93 117.88 65.25 117.97   Q 60.79 118.01 57.08 120.20   Q 57.05 120.22 54.89 121.79   Q 49.91 125.41 45.46 120.50   Q 45.81 119.61 45.06 118.19   Q 43.42 115.06 43.89 110.83   Q 44.00 109.85 44.55 109.38   Q 45.45 108.62 46.22 109.58   Q 46.59 110.05 46.96 110.21   Q 50.97 111.94 55.04 110.14   Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanda);
export default __webpack_public_path__ + "static/media/Panda.49581383b7254520b91cc33f81202a89.svg";
export { ForwardRef as ReactComponent };